<template>
  <div class="tabBar">
    <div class="rightTabs">
      <div id="tabMargin" style="height:30px;"></div>
      <div class="tabsContent">
        <ul class="tabBox clearfix">
          <!-- tabs标签 -->
          <li title="" v-for="(item) in openedPageRouters"
              :class="{'current': item.fullPath == $route.fullPath,}"
              :key="item.fullPath"
              @click="onClick(item)"
          >
            <span :class="item.meta.newMoreOpen ? (item.params.tit ? 'txt tabs_js_text' : 'txt1 tabs_js_text') : 'txt '+ matchTabIcon(item.name)">
              {{ item.meta.newMoreOpen ? (item.params.tit ? item.params.tit : $i18n.t('wm_lang_b7612b')) : ''}}
            </span>
            <!--<span class="txt tabs_js_text">{{ item.meta.newMoreOpen ? item.params.tit : item.meta.title}}</span>-->
            <!--<span class="icon tabs_js_home"></span>-->
            <a href="javascript:void(0);"
               class="close"
               :title="$i18n.t('wm_lang_873178')"
               v-show="item.name ==='newRead' || item.name ==='write' || item.name ==='sent'"
               @click.stop="onClose(item)"
               @contextmenu.prevent.stop=""
               :style="openedPageRouters.length <= 1 ? 'width:0;' : ''"
            ><i class="el-icon-circle-close"></i></a>
          </li>
          <!--<li title="WM"+this.$i18n.t('wm_lang_c9a507')>-->
            <!--<span class="txt tabs_js_text">WM{{$t("wm_lang_html_0f87e0")}}</span>-->
            <!--<a href="javascript:void(0);" class="close" title=this.$i18n.t('wm_lang_873178')><i class="el-icon-circle-close"></i></a>-->
          <!--</li>-->
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pageTabs',
  props: {
    keepAliveComponentInstance: {}, //keep-alive控件实例对象
    blankRouteName: {
      type: String,
      default: "blank",
    }, //空白路由的name值
    tabsShow: {
      type: Boolean
    }
  },
  data() {
    return {
      openedPageRouters: [], //已打开的路由页面
      vueInstances: [],
      routerOrderRecord: []
    };
  },
  watch: {
    //当路由变更时，执行打开页面的方法
    $route: {
      handler(v) {
        this.openPage(v);
      },
      immediate: true
    },
  },
  mounted() {
    //添加点击关闭右键菜单
    // window.addEventListener("click", this.closeContextMenu);
    this.$EventBus.$off("closeTabPage");
    let self = this;
    this.$EventBus.$on("closeTabPage",function(data){
      // console.log(data)
      // let mailIds = data.map(item =>{return item.emailId});
      let mailIds = data;
      let oRouters = [];
      let delRouters = [];
      self.openedPageRouters.forEach((route) => {
        if(route.name === 'newRead') {
          oRouters.push(route);
        }
      });
      // console.log(oRouters)
      oRouters.forEach((item) => {
        // console.log(item)
        if(mailIds.includes(item.params.id)){
          // console.log(item)
          delRouters.push(item);
          // self.onClose(item);
          // if(self.openedPageRouters.length <= 2){
          //   self.$emit('update:tabsShow', false);
          // }
          // self.delPageRoute(item);
        }
        // return item
      });
      // console.log(delRouters);
      delRouters.forEach((item) => {
        // console.log(item)
        self.onClose(item);
        // if(self.openedPageRouters.length <= 2){
        //   self.$emit('update:tabsShow', false);
        // }
        // self.delPageRoute(item);
      })
    });
    this.$EventBus.$off("closeWritePage");
    this.$EventBus.$on("closeWritePage",function(data){
      let oRouters = self.openedPageRouters;
      let delRouters = oRouters.find(item => {
        return item.name === 'write'
      });
      if(delRouters) {
        self.onClose(delRouters, data.type);
      }
      // self.onClose(delRouters[0], data.type);
    });
    this.$EventBus.$off("closeSentPage");
    this.$EventBus.$on("closeSentPage",function(){
      let oRouters = self.openedPageRouters;
      let delRouters = oRouters.filter(item => {
        return item.name === 'sent'
      });
      if(delRouters[0]) {
        self.onClose(delRouters[0]);
      }
    });
    this.$EventBus.$off("clearWriteKeepAlive");
    this.$EventBus.$on("clearWriteKeepAlive",function(){
      self.clearKeepAliveCache()
    })
  },
  destroyed() {
    // window.removeEventListener("click", this.closeContextMenu);
  },
  methods: {
    getAllChildVues(vueInstanceChildren) {
      vueInstanceChildren.forEach(childVue => {
        this.vueInstances.push(childVue);
        if(childVue.$children && childVue.$children.length > 0) {
          this.getAllChildVues(childVue.$children);
        }
      })
    },
    matchTabIcon(type) {
      switch (type) {
        case 'info':
          return 'icon tabs_js_home';
          break;
        case  'read':
          return 'icon tabs_js_email';
          break;
        case  'write':
          return 'icon tabs_js_write';
          break;
        case  'sent':
          return 'icon tabs_js_sent';
          break;
        case  'address':
          return 'icon tabs_js_address';
          break;
        case  'setting':
          return 'icon tabs_js_set';
          break;
        case  'largeAttach':
          return 'icon tabs_js_home';
          break;
        default:
          return 'icon tabs_js_set';
      }
    },
    //打开页面
    openPage(route) {
      if (route.name === this.blankRouteName) {
          return;
      }
      if(route.meta.commonTab) {
        this.routerOrderRecord = this.routerOrderRecord.filter((router,index)=>{
          return !router.meta.commonTab
        })
      } else {
        this.routerOrderRecord = this.routerOrderRecord.filter((router,index)=>{
          return route.fullPath !== router.fullPath
        })
      }
      // console.log(this.routerOrderRecord.indexOf(route));
      this.routerOrderRecord.push(route);
      // console.log(route);
      // console.log(this.routerOrderRecord);
      // console.log(this.openedPageRouters);
      //页签显示及隐藏
      if(route.name === 'newRead' || route.name === 'write' || route.name === 'sent'){
          this.$emit('update:tabsShow', true);
      }

      if (route.meta.commonTab) {
          if(this.openedPageRouters.length > 0){
              let openedCommomTabRoute = this.openedPageRouters.find(
                  (item) => item.meta.commonTab
              );
              this.openedPageRouters.splice(
                this.openedPageRouters.indexOf(openedCommomTabRoute),
                1,
                route
              );
          } else {
              this.openedPageRouters.push(route);
          }
          this.$store.commit('SET_COMMONTADROUTE',route);
          // console.log('isCommonTab')
      } else {
          if(route.meta.writeTab){
              let openedWritePageRoute = this.openedPageRouters.find(
                  (item) => item.name === 'write' || item.name === 'sent'
              );
              if(openedWritePageRoute){
                  // this.delRouteCache(openedWritePageRoute.fullPath);
                  this.openedPageRouters.splice(
                      this.openedPageRouters.indexOf(openedWritePageRoute),
                      1,
                      route
                  );
              } else {
                  this.openedPageRouters.splice(1, 0, route);
              }
          } else if (route.meta.newMoreOpen){
              // console.log(route)
              // console.log(this.openedPageRouters)
              let openNewReadRouters = this.openedPageRouters.filter(
                  (item) => item.name === 'newRead'
              );
              //点页签切换路由时params会被忽略
              let currMid = route.params.id;
              // console.log(currMid)
              let isSameMail = openNewReadRouters.some(
                  (item) => item.params.id === currMid
              );
              let openedReadPageRoute = openNewReadRouters.find(
                  (item) => item.params.id === currMid
              );
              // console.log(openedReadPageRoute)
              if (isSameMail) {
                  // console.log(11)
                // console.log(this.openedPageRouters.indexOf(openedReadPageRoute))
                //   this.delRouteCache(openedReadPageRoute.fullPath);
                  this.openedPageRouters.splice(
                      this.openedPageRouters.indexOf(openedReadPageRoute),
                      1,
                      route
                  );
              } else {
                  // console.log(22)
                  let hasWrite = this.openedPageRouters.some(
                      (item) => item.name === 'write'
                  );
                  if(hasWrite){
                      this.openedPageRouters.splice(2, 0, route);
                  } else {
                      this.openedPageRouters.splice(1, 0, route);
                  }
              }
          } else {
              this.openedPageRouters.push(route);
          }
      }
    },
    //点击页面标签卡时
    onClick(route) {
        if (route.fullPath !== this.$route.fullPath) {
            if(route.name === 'newRead'){
                // params在路由有path时会被忽略
                this.$router.push({name: 'newRead', params: route.params, query: route.query});
            } else if(route.name === 'write') {
              let routeParams = {}
              if(route.params){ //增加点击页签到写信情况的标识
                routeParams = {...route.params,...{tabRoute: true}}
              }
              this.$router.push({name: route.name, params: routeParams});
            } else {
                // this.$router.push(route.fullPath);
                this.$router.push({name: route.name});
            }

            if(route.name !== 'write' && route.name !== 'sent') {
              this.$EventBus.$emit("changeTabDraftSave");
            }
            // this.$router.push(route.fullPath);
          // console.log(this.keepAliveComponentInstance)
        }
    },
    closeHandle(route, destroyWrite) {
      if(destroyWrite) {
        this.destroyWriteVue(route);
      }
      //关闭写信页签
      if(this.openedPageRouters.length <= 2){
        this.$emit('update:tabsShow', false);
      }
      // let index = this.openedPageRouters.indexOf(route);
      // this.delPageRoute(route);
      let routeIndex = this.openedPageRouters.indexOf(route);
      if (routeIndex >= 0) {
        this.openedPageRouters.splice(routeIndex, 1);
      }

      this.routerOrderRecord = this.routerOrderRecord.filter((router,index)=>{
        return route.fullPath !== router.fullPath
      });

      // console.log(this.routerOrderRecord);
      // console.log(this.routerOrderRecord[this.routerOrderRecord.length-1]);

      let nextIndex = this.openedPageRouters.indexOf(this.routerOrderRecord[this.routerOrderRecord.length-1]);
      // console.log(nextIndex);
      if (route.fullPath === this.$route.fullPath) {
        this.$router.replace(
          this.openedPageRouters[nextIndex]
        );
      }
    },
    //关闭页面标签时
    onClose(route, type) {
      // if(this.openedPageRouters.length <= 2){
      //     this.$emit('update:tabsShow', false);
      // }
      // let index = this.openedPageRouters.indexOf(route);
      // this.delPageRoute(route);
      // if (route.fullPath === this.$route.fullPath) {
      //   //删除页面后，跳转到上一页面
      //   this.$router.replace(
      //     this.openedPageRouters[index === 0 ? 0 : index - 1]
      //   );
      // }
      if(route.name === 'write'){
        this.$EventBus.$emit("getDraftDataMd5");
        // console.log(this.$store.getters.currDraftDataChange);
        if(this.$store.getters.currDraftDataChange && type !== 'sent') {
          this.$confirm(this.$i18n.t('wm_lang_f7a9dd')+','+this.$i18n.t('wm_lang_b1c5ea'), this.$i18n.t('wm_lang_c45357'), {
            distinguishCancelAndClose: true,
            confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
            cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            this.$EventBus.$emit("dialogSaveDraft");
            this.closeHandle(route, true);
            // this.destroyWriteVue(route);
          }).catch(action => {
            if(action === 'cancel') {
              this.closeHandle(route, true);
            } else {
              //
            }
          });
        } else {
          this.closeHandle(route, true);
        }
      } else {
        this.closeHandle(route);
      }
    },
    destroyWriteVue(route) {
      let commonTabFlag = false; //commonTab是设置和通讯录时写信vue实例无法销毁导致编辑器报错
      for (let i = 0; i < this.openedPageRouters.length; i++) {
        if (this.openedPageRouters[i].name === 'info' || this.openedPageRouters[i].name === 'read' || this.openedPageRouters[i].name === 'largeAttach') {
          commonTabFlag = true;
          break;
        }
      }
      if(route.name === 'write' && commonTabFlag){
        //清除写信组件实例
        this.clearKeepAliveCache()
      }
    },
    clearKeepAliveCache() {
      this.getAllChildVues(this.$parent.$children);
      let writeVue = null;
      this.vueInstances.forEach(vueItem => {
        if(vueItem.$vnode.tag.includes('WriteMail')) {
          writeVue = vueItem;
        }
      });
      if(!writeVue) {
        return;
      }
      // this.removeKeepAliveCache(writeVue);
      if (writeVue.$vnode && writeVue.$vnode.data.keepAlive && writeVue.$vnode.parent) {
        const tag = writeVue.$vnode.tag;
        let caches = writeVue.$vnode.parent.componentInstance.cache;
        let keys = writeVue.$vnode.parent.componentInstance.keys;
        for (let [key, cache] of Object.entries(caches)) {
          if (cache.tag === tag) {
            if (keys.length > 0 && keys.includes(key)) {
              keys.splice(keys.indexOf(key), 1);
            }
            // console.log(caches[key]);
            delete caches[key];
            break;
          }
        }
      }
      // console.log(writeVue.$destroy);
      writeVue.$destroy();
    },
    // removeKeepAliveCache (writeThis) {
    //   if (writeThis.$vnode && writeThis.$vnode.data.keepAlive && writeThis.$vnode.parent) {
    //     const tag = writeThis.$vnode.tag;
    //     let caches = writeThis.$vnode.parent.componentInstance.cache;
    //     let keys = writeThis.$vnode.parent.componentInstance.keys;
    //     for (let [key, cache] of Object.entries(caches)) {
    //       if (cache.tag === tag) {
    //         if (keys.length > 0 && keys.includes(key)) {
    //           keys.splice(keys.indexOf(key), 1);
    //         }
    //         delete caches[key];
    //       }
    //     }
    //   }
    //   writeThis.$destroy();
    // },
    //根据路径获取索引
    getPageRouteIndex(fullPath) {
      for (let i = 0; i < this.openedPageRouters.length; i++) {
        if (this.openedPageRouters[i].fullPath === fullPath) {
          return i;
        }
      }
    },
    //删除页面
    delPageRoute(route) {
      let routeIndex = this.openedPageRouters.indexOf(route);
      if (routeIndex >= 0) {
        this.openedPageRouters.splice(routeIndex, 1);
      }
      // this.delRouteCache(route);
    },
    //删除页面缓存
    delRouteCache(route) {
      // console.log(this.openedPageRouters);
      // if(route.name === 'write' && commonTabFlag){
      //   this.destroyWriteVue();
      // }
    },
    // delRouteCache(key) {
    //   // console.log(key)
    //   // console.log(this.keepAliveComponentInstance);
    //   // let cache = this.keepAliveComponentInstance.cache;
    //   // let keys = this.keepAliveComponentInstance.keys;
    //   // console.log(cache)
    //   // console.log(keys)
    //   // for (let i = 0; i < keys.length; i++) {
    //   //   if (keys[i] === key) {
    //   //     keys.splice(i, 1);
    //   //     console.log(cache[key]);
    //   //     if (cache[key] != null) {
    //   //       delete cache[key];
    //   //     }
    //   //     break;
    //   //   }
    //   // }
    // },
  },
};
</script>
<style scoped>
  .tabBar{
    width: 80px;
    height: calc(100vh - 66px);
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/sub/pageTabs.vue